var _DomainActionsErrorsM, _DomainActionsErrorsM2, _DomainActionsErrorsM3;
import { DomainProductTypeEnum } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box } from '@wix/design-system';
import { CoreDomainSearchStore, DomainActionsErrorsMap, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GeneralAnonymousOverride, SubdomainRootTaken } from '../../../Components';
import { Base44Label } from '../../../Components/Base44Label';
import { Base44ResultsHeader } from '../../../Components/Headers';
import { BackButton } from '../../../Components/Headers/HeaderWrapper';
import { Base44VoucherBanner } from '../../../Components/VoucherBanner/Base44VoucherBanner';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { SEARCH_QUERY_PARAMS } from '../../../constants';
import { ResultsLayout, ResultsRecommendations, ResultsSearchBar } from '../../ResultsLayout';
import s from '../../anonymousResultsPage.scss';
const InlineMobileActions = _ref => {
  let {
    pricing,
    getItButton
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "space-between",
    verticalAlign: "middle",
    width: "100%"
  }, pricing, getItButton);
};
const customConfiguration = {
  ...(((_DomainActionsErrorsM = DomainActionsErrorsMap.assign) == null ? void 0 : _DomainActionsErrorsM.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM2 = DomainActionsErrorsMap.connect) == null ? void 0 : _DomainActionsErrorsM2.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM3 = DomainActionsErrorsMap.transfer) == null ? void 0 : _DomainActionsErrorsM3.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  transfer: GeneralAnonymousOverride,
  connect: GeneralAnonymousOverride,
  subdomainRootIsNotConnected: SubdomainRootTaken,
  domainTakenInWix: GeneralAnonymousOverride,
  subdomainTakenInWix: SubdomainRootTaken,
  noStatus: GeneralAnonymousOverride
};
export const EmbeddedResultsPage = _ref2 => {
  let {
    handlers,
    externalViewer,
    deviceType,
    onSearchSubmit
  } = _ref2;
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, {
    overrides: {
      getPurchasePermissions: {
        hasPermission: true
      }
    }
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(EmbeddedResultsPageContent, {
    deviceType: deviceType,
    onSearchSubmit: onSearchSubmit
  })));
};
export const EmbeddedResultsPageContent = _ref3 => {
  let {
    deviceType,
    onSearchSubmit
  } = _ref3;
  const isMobile = useIsMobile();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const handleBackClick = useCallback(() => {
    DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
      ctaClick: 'back_button'
    });
    const params = new URLSearchParams(search);
    SEARCH_QUERY_PARAMS.forEach(param => params.delete(param));
    const nextSearch = params.toString();
    history.push(nextSearch ? `/?${nextSearch}` : '/');
    setTimeout(() => {
      CoreDomainSearchStore.resetStore();
    });
  }, [history, search]);
  return /*#__PURE__*/React.createElement(ResultsLayout, {
    biViewMode: "Base44",
    productType: DomainProductTypeEnum.BASE44,
    querySubmitPath: "/results",
    deviceType: deviceType,
    headerPadding: isMobile ? '0 SP4' : '16px SP6',
    headerTop: 0,
    searchBarFullWidth: true,
    searchBar: /*#__PURE__*/React.createElement(ResultsSearchBar, {
      onSearchSubmit: onSearchSubmit
    }),
    header: /*#__PURE__*/React.createElement(Base44ResultsHeader, {
      onBackClick: isMobile ? undefined : handleBackClick
    }),
    voucher: /*#__PURE__*/React.createElement(Base44VoucherBanner, null),
    mobileBackButton: /*#__PURE__*/React.createElement(Box, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(BackButton, {
      onClick: handleBackClick
    }))
  }, /*#__PURE__*/React.createElement(ResultsRecommendations, {
    showHeroCard: true,
    className: s.centeredContent,
    isLeanView: true,
    hideAiInsights: true,
    hideAlternativesHeading: true,
    hideFreeWithSitePlanBadge: true,
    pricingOptimized: false,
    Layouts: {
      Label: Base44Label,
      MobileActions: InlineMobileActions
    },
    width: "100%",
    padding: isMobile ? '0 SP4' : '0 SP6'
  }));
};
//# sourceMappingURL=EmbeddedResultsPage.js.map